export default "__VITE_ASSET__XHJNtilI__"